import { render, staticRenderFns } from "./ClassesDataTable.vue?vue&type=template&id=521d56a6"
import script from "./ClassesDataTable.vue?vue&type=script&lang=js"
export * from "./ClassesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports